import Isotope from "isotope-layout";

window.addEventListener("DOMContentLoaded", () => {
	let home_feed = document.querySelector("body.home .news_feed");
	let is_archive = document.querySelector(".news_feed.archive");
	let filters = document.querySelectorAll(".newsfilters select");
	let reset_filters = document.getElementById("reset_filters");
	if (is_archive) {
		let $iso = new Isotope(is_archive, {
			itemSelector: ".news",
			layoutMode: "fitRows",
		});
		if (filters) {
			filters.forEach((el) => {
				el.addEventListener("change", () => {
					let concat_filter = `.${document.getElementById("byauthor").value}.${document.getElementById("bytheme").value}.${
						document.getElementById("bytags").value
					}.${document.getElementById("bydate").value}`;
					$iso.arrange({ filter: concat_filter });
				});
			});
		}
		if (reset_filters) {
			reset_filters.addEventListener("click", () => {
				setTimeout(() => {
					let concat_filter = `.${document.getElementById("byauthor").value}.${document.getElementById("bytheme").value}.${
						document.getElementById("bytags").value
					}.${document.getElementById("bydate").value}`;
					$iso.arrange({ filter: concat_filter });
				}, 100);
			});
		}
	}
});
